import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-4 text-stone-700 text-sm leading-relaxed" data-id="element-21">
    <p className="text-xs text-stone-500" data-id="element-22">
      Última actualización: {new Date().getFullYear()}
    </p>
    <p data-id="element-23">
      En <strong data-id="element-24">Mil Hojas Pro</strong> nos comprometemos a proteger tu
      privacidad. Esta política describe cómo recopilamos, usamos y protegemos
      tu información personal.
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-25">
      1. Información que recopilamos
    </h3>
    <p data-id="element-26">
      Recopilamos únicamente la información necesaria para procesar tu compra:
      nombre, dirección de correo electrónico y datos de pago (procesados de
      forma segura por nuestro proveedor de pagos).
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-27">
      2. Uso de la información
    </h3>
    <p data-id="element-28">Utilizamos tu información exclusivamente para:</p>
    <ul className="list-disc pl-5 space-y-1" data-id="element-29">
      <li data-id="element-30">Procesar y confirmar tu compra.</li>
      <li data-id="element-31">Enviarte el acceso a tu producto digital.</li>
      <li data-id="element-32">Responder a tus consultas de soporte.</li>
    </ul>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-33">
      3. Compartir información
    </h3>
    <p data-id="element-34">
      No vendemos, alquilamos ni compartimos tu información personal con
      terceros, salvo lo estrictamente necesario para procesar pagos (ej.
      Stripe, PayPal).
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-35">4. Seguridad</h3>
    <p data-id="element-36">
      Implementamos medidas de seguridad estándar de la industria para proteger
      tu información. Todas las transacciones están encriptadas mediante SSL.
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-37">5. Tus derechos</h3>
    <p data-id="element-38">
      Tienes derecho a acceder, corregir o eliminar tu información personal en
      cualquier momento. Para ejercer estos derechos, contáctanos.
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-39">
      6. Cambios a esta política
    </h3>
    <p data-id="element-40">
      Podemos actualizar esta política ocasionalmente. Te notificaremos de
      cambios significativos por correo electrónico.
    </p>
  </div>;
const termsContent = <div className="space-y-4 text-stone-700 text-sm leading-relaxed" data-id="element-41">
    <p className="text-xs text-stone-500" data-id="element-42">
      Última actualización: {new Date().getFullYear()}
    </p>
    <p data-id="element-43">
      Al adquirir <strong data-id="element-44">Mil Hojas Pro</strong>, aceptas los siguientes
      términos y condiciones. Por favor, léelos detenidamente.
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-45">1. Producto digital</h3>
    <p data-id="element-46">
      Mil Hojas Pro es un producto digital (PDF). Una vez completada la compra,
      recibirás acceso inmediato y de por vida al material.
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-47">2. Uso personal</h3>
    <p data-id="element-48">
      Este producto es para uso personal exclusivamente. Queda prohibida la
      reproducción, distribución, reventa o compartición del contenido sin
      autorización expresa por escrito.
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-49">
      3. Garantía de devolución
    </h3>
    <p data-id="element-50">
      Ofrecemos una garantía de satisfacción. Si aplicas las técnicas y tu Mil
      Hojas no queda crujiente, te reembolsamos el 100% de tu pago sin preguntas
      dentro de los 30 días posteriores a la compra.
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-51">
      4. Propiedad intelectual
    </h3>
    <p data-id="element-52">
      Todo el contenido de Mil Hojas Pro, incluyendo textos, imágenes y
      metodologías, es propiedad exclusiva de Mil Hojas Pro y está protegido por
      las leyes de derechos de autor.
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-53">
      5. Limitación de responsabilidad
    </h3>
    <p data-id="element-54">
      Los resultados pueden variar según las condiciones individuales de cada
      usuario (humedad, altitud, equipo de cocina, etc.). Mil Hojas Pro no
      garantiza resultados idénticos para todos los usuarios.
    </p>
    <h3 className="font-bold text-stone-900 text-base" data-id="element-55">6. Modificaciones</h3>
    <p data-id="element-56">
      Nos reservamos el derecho de actualizar estos términos en cualquier
      momento. El uso continuado del producto implica la aceptación de los
      términos vigentes.
    </p>
  </div>;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const closeModal = () => setOpenModal(null);
  const modalConfig = {
    privacy: {
      title: 'Política de Privacidad',
      content: privacyContent
    },
    terms: {
      title: 'Términos y Condiciones',
      content: termsContent
    }
  };
  return <>
      <footer className="bg-stone-900 text-stone-400 py-12 border-t border-stone-800" data-id="element-57">
        <div className="container mx-auto px-4 text-center" data-id="element-58">
          <p className="font-serif font-bold text-xl text-white mb-4" data-id="element-59">
            Mil Hojas <span className="text-amber-500" data-id="element-60">Pro</span>
          </p>
          <p className="text-sm mb-8 max-w-md mx-auto" data-id="element-61">
            El método definitivo para lograr el hojaldre perfecto en casa, sin
            importar la humedad de tu ciudad.
          </p>
          <div className="flex justify-center gap-6 text-sm mb-8" data-id="element-62">
            <button onClick={() => setOpenModal('terms')} className="hover:text-white transition-colors underline-offset-2 hover:underline" data-id="element-63">
              Términos y Condiciones
            </button>
            <button onClick={() => setOpenModal('privacy')} className="hover:text-white transition-colors underline-offset-2 hover:underline" data-id="element-64">
              Política de Privacidad
            </button>
          </div>
          <p className="text-xs text-stone-600" data-id="element-65">
            © {new Date().getFullYear()} Mil Hojas Pro. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {openModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={closeModal} data-id="element-66">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-67" />

          {/* Modal Panel */}
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-68">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-stone-100 bg-stone-50 flex-shrink-0" data-id="element-69">
              <h2 className="font-serif font-bold text-stone-900 text-lg" data-id="element-70">
                {modalConfig[openModal].title}
              </h2>
              <button onClick={closeModal} className="w-8 h-8 flex items-center justify-center rounded-full text-stone-400 hover:text-stone-700 hover:bg-stone-200 transition-colors" aria-label="Cerrar" data-id="element-71">
                <X className="w-4 h-4" data-id="element-72" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="overflow-y-auto px-6 py-5 flex-1" data-id="element-73">
              {modalConfig[openModal].content}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-stone-100 bg-stone-50 flex-shrink-0" data-id="element-74">
              <button onClick={closeModal} className="w-full h-10 bg-stone-900 text-white rounded-lg text-sm font-medium hover:bg-stone-700 transition-colors" data-id="element-75">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}